import { defineStore } from 'pinia'
import { toast, variant } from '@/core/helper/utility'
import { httpStatusCode } from '@/core/helper/httpStatusCode';
import { GetCurrentUser } from '@/infrastructure/repositories/accountRepository';

const ACCOUNT_KEY = process.env.VUE_APP_TOKEN_ACCOUNT_KEY;
const REFRESH_KEY = process.env.VUE_APP_REFRESH_TOKEN_KEY;

export const useAccountStore = defineStore('user', {
    state: () => ({
        login: {
            email: null,
            password: null
        },
        user: {
            token: null,
            refreshToken: null,
            identification: null,
            userName: null,
            email: null,
            password: null,
            photo: null,
            phone: null,
            staff: false,
            idUserStatus: 0,
            nextChangePassword: null,
            expires: null,
            roles: []
        },
    }),
    getters: {
        getAccessToken(state) {
            return state.user.token ?? localStorage.getItem(ACCOUNT_KEY);
        },
        getRefreshToken(state) {
            return state.user.refreshToken ?? localStorage.getItem(REFRESH_KEY);
        },
        getRoles(state){
            return state.user.roles;
        },
        isLoggin() {
            return this.getAccessToken ?? false;
        }
    },
    actions: {
        setToken(user){
            this.user = user.data.value;
            this.updateTokes(user.data.token, user.data.refreshToken);
        },
        async getCurrentUser() {
            try {
                const response = await GetCurrentUser();

                if(response.status == httpStatusCode.OK){
                    this.user = response.data.value;
                    return response.data.value;
                }else{
                    toast({
                        collection: true,
                        variant: variant.error,
                        title: response.data.title,
                        body:  response.data.messages
                    });
                }
            } catch (error) {
                toast({
                    variant: variant.error,
                    title: 'Current User',
                    body: 'Failed to load current user, please call to contact center'
                });
        
                throw new Error(error);
            }
        },
        updateTokes(accessToken, refreshToken){
            this.user.token = accessToken;
            this.user.refreshToken = refreshToken;
            localStorage.setItem(ACCOUNT_KEY, accessToken);
            localStorage.setItem(REFRESH_KEY, refreshToken);
        },
        sigOut() {
            localStorage.clear();
            this.$reset();
        }
    }
});